// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"table_headerCell__1P6Uv","minimal":"table_minimal__3v67S","centered":"table_centered__2MWMJ","cell":"table_cell__18ev3","table":"table_table__3Q7ay"};